import { Affix, Button, Layout, Menu } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import AppFooter from '../AppFooter';
import AppHeader from '../AppHeader';
import Authed from '../_authed';
import ContextLoadingChecker from '../ContextLoadingChecker';
import ToolkitNavBar from './ToolkitNavBar';
import { ToolkitsAccessProvider } from '../../lib/ToolkitsAccessContext';
import { ToolkitsIcon } from '../../components/images/NavIcons';
import { useState } from 'react';
const {
  Content,
  Sider
} = Layout;
const currentSection = {
  icon: <ToolkitsIcon />,
  name: 'Teacher Toolkits'
};
const siderStyles = {
  background: '#fff',
  height: 'calc(100vh - 64px)',
  position: 'sticky',
  insetInlineStart: 0,
  top: 64,
  bottom: 0,
  scrollbarWidth: 'thin',
  scrollbarGutter: 'stable',
  overflowY: 'auto'
};
export default (({
  children
}) => {
  const [collapsed, setCollapsed] = useState(false);
  return <Authed>
      <Affix>
        <AppHeader currentSection={currentSection} />
      </Affix>
      <ContextLoadingChecker>
        <ToolkitsAccessProvider>
          <Layout>
            <Sider collapsible trigger={null} collapsed={collapsed} style={siderStyles} width={300} className="toolkitSider" theme="light" breakpoint="lg" collapsedWidth="100" onBreakpoint={broken => {
            setCollapsed(broken);
          }}>
              <Button type="ghost" varient="filled" size="large" block={true} onClick={() => setCollapsed(!collapsed)} icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />} iconPosition="end">
                {!collapsed ? 'Show Less' : ''}{' '}
              </Button>

              <ToolkitNavBar isCollapsed={collapsed} setCollapsed={setCollapsed} />
            </Sider>
            <Layout>
              <Content style={{
              margin: 20,
              marginTop: 0,
              overflow: 'initial'
            }} children={children} />
              <AppFooter />
            </Layout>
          </Layout>
        </ToolkitsAccessProvider>
      </ContextLoadingChecker>
    </Authed>;
});